import { props, createActionGroup, emptyProps } from '@ngrx/store';
import { CourseCategory } from './model/course-category.model';
import { ErrorCode } from '../../models/error-code.model';

export const CourseCategoryApiActions = createActionGroup({
    source: 'API/Course Category',
    events: {
        'load course categories': emptyProps(),
        'create course category': props<{ courseCategory: CourseCategory }>()
    }
});

export const CourseCategoryActions = createActionGroup({
    source: 'Course Category',
    events: {
        'load course categories success': props<{ courseCategories: CourseCategory[] }>(),
        'load course categories failure': props<{ error: ErrorCode }>(),
        'create course category success': props<{ courseCategory: CourseCategory }>(),
        'create course category failure': props<{ error: ErrorCode }>()
    }
});
